import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'
import { toast } from 'react-hot-toast'
import { OrganizationSubscription } from 'interfaces/organization-subscription'

type OrgSubscriptionData = Partial<OrganizationSubscription> & {
  reset_trial?: boolean
}

const createOrganizationSubscription = async (
  orgId: string,
  subscriptionId: string
) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/organization_subscriptions`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({
        subscription_id: subscriptionId,
      }),
    }
  )
  response = handleErrors(response)
  const json = await response.json()
  return json
}

const useCreateOrganizationSubscription = (orgId: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    (subscriptionId: string) =>
      createOrganizationSubscription(orgId, subscriptionId),
    {
      onError: (e: Error) => {
        toast('Error creating organization subscription')
      },
      onSuccess: (data) => {
        toast('Successfully created organization subscription!')
      },
      onSettled: () => {
        queryClient.invalidateQueries(organizationsKeys.detail(orgId))
      },
    }
  )
}

export default useCreateOrganizationSubscription
